package pl.decks.personal.components.widgets.ranks.military

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import pl.decks.personal.components.widgets.ranks.Rank
import pl.decks.personal.theme.SitePalette
import pl.decks.personal.extensions.toSitePalette

enum class ParaMilitaryRank(
    override val slot: Rank.Slot,
    override val title: String,
    private val coloring: (SitePalette) -> SitePalette.MilitaryBadgeColors,
) : Rank {
    PRIVATE1(Rank.Slot.S1, "Trainee", { it.military.low }),
    PRIVATE2(Rank.Slot.S2, "Informed novice", { it.military.low }),
    PRIVATE3(Rank.Slot.S3, "Rusty dog", { it.military.low }),
    SERGEANT1(Rank.Slot.S4, "Field ready", { it.military.mid }),
    SERGEANT2(Rank.Slot.S5, "Hassle-free maintainer", { it.military.mid }),
    SERGEANT3(Rank.Slot.S6, "Engaged contributor", { it.military.mid }),
    ENSIGN1(Rank.Slot.S7, "Special agent", { it.military.high }),
    ENSIGN2(Rank.Slot.S8, "One-man army", { it.military.high }),
    ENSIGN3(Rank.Slot.S9, "Nuclear", { it.military.high }),
    ;

    @Composable
    override fun render(modifier: Modifier) = ParaMilitaryBadge(
        rank = this,
        narrowingWidth = 0.15f,
        narrowingHeight = 0.15f,
        coloring = coloring(ColorMode.current.toSitePalette()),
        modifier = modifier,
    )
}
